<script lang="ts" setup>
  import { Button, Card, Icon } from '@skillstown/leap';
  import { BlobClient } from '@/data/BlobClient';
  import { MimeType } from '~~/data/enums/MimeType';
  import { useDrawer } from '~~/stores/drawer';

  const drawer = useDrawer();

  const { cardPadding } = useLeapCustomizations();

  function onClickNavigateToTermsAndConditions(): void {
    const documentLocation = `${window.location.origin}/Algemene_voorwaarden_Wft_Triple_A.pdf`;
    window.open(documentLocation, '_blank');
  }

  async function onClickDownloadTermsAndConditions(): Promise<void> {
    await new BlobClient(
      'Algemene_voorwaarden_Wft_Triple_A.pdf'
    ).fetchAndDownloadFromPublicDirectory('Algemene_voorwaarden_Wft_Triple_A.pdf', MimeType.PDF);
  }

  function onClickNavigateToPrivacyPolicy(): void {
    const documentLocation = `${window.location.origin}/privacyverklaring WFT Triple A.pdf`;
    window.open(documentLocation, '_blank');
  }

  async function onClickDownloadPrivacyPolicy(): Promise<void> {
    await new BlobClient('privacyverklaring WFT Triple A.pdf').fetchAndDownloadFromPublicDirectory(
      'privacyverklaring WFT Triple A.pdf',
      MimeType.PDF
    );
  }

  function onClickClose(): void {
    drawer.close();
  }
</script>

<template>
  <ModalBase
    :title="$t('terms_and_conditions')"
    :isFullScreen="true"
    :removeFooter="true"
    :onClose="onClickClose"
  >
    <div
      class="space-y-2"
      :padding="cardPadding"
    >
      <BaseSubtitle>NIBE-SVV</BaseSubtitle>
      <p class="text-sm">
        {{ $t('terms_and_conditions__documents_explainer_text') }}
      </p>
      <div class="p-4">
        <div class="flex items-center justify-between">
          <h6 class="text-sm font-semibold">{{ $t('terms_and_conditions') }}</h6>
          <div class="flex items-center">
            <Icon
              icon="download"
              class="mx-2 cursor-pointer"
              @click="onClickDownloadTermsAndConditions"
            ></Icon>
            <Icon
              icon="duplicate"
              class="mx-2 cursor-pointer"
              @click="onClickNavigateToTermsAndConditions"
            ></Icon>
          </div>
        </div>

        <div class="mt-1 flex items-center justify-between">
          <h6 class="text-sm font-semibold">{{ $t('privacy_policy') }}</h6>
          <div class="flex items-center">
            <Icon
              icon="download"
              class="mx-2 cursor-pointer"
              @click="onClickDownloadPrivacyPolicy"
            ></Icon>
            <Icon
              icon="duplicate"
              class="mx-2 cursor-pointer"
              @click="onClickNavigateToPrivacyPolicy"
            ></Icon>
          </div>
        </div>
      </div>
    </div>
  </ModalBase>
</template>

<style lang="postcss" scoped>
  .support-card {
    @apply grid gap-6 rounded-lg bg-white p-8;
    h3 {
      @apply font-bold;
    }
    p {
      @apply text-base font-light;
    }
  }
</style>
